import { Component, Injector } from '@angular/core';
import { TrackingVehicleNumberService, TotalVehicleNumberService } from '../../ve.service'
import { BaseGridComponent } from '../base-grid/base-grid.component';
import { CgpConfirmationDialogService } from '../../../../shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { CgpSnackbarService } from '../../../../shared/cgp-snackbar/cgp-snackbar.service';
import { Validators } from '@angular/forms';
import { FilterableService } from '../../../../shared/filterable-service';

@Component({
  selector: 'app-tracking-vehicle-number',
  templateUrl: '../base-grid/base-grid.component.html',
})
export class TrackingVehicleNumberComponent extends BaseGridComponent {
  public descMaxLength: number = null;
  private readonly totalVehService = new FilterableService();

  constructor(
    cgpConfirmationDialogService: CgpConfirmationDialogService,
    cgpSnackbarService: CgpSnackbarService,
    service: TrackingVehicleNumberService,
    injector: Injector,
  ) {
    super(cgpConfirmationDialogService, cgpSnackbarService, service, injector);
    this.descMaxLength = 20;
    this.appCardTitle = 'Tracking Vehicle Numbers';
    this.path = '/?activeOnly=false';

    this.columns = [
      {
        field: 'Description',
        title: 'Tracking Vehicle Number',
      },
      {
        field: 'IsActive',
        title: 'Active',
        editor: 'boolean',
        filter: 'boolean'
      },
    ];

    this.editForm = this.formBuilder.group({
      Id: [],
      Description: ['', Validators.required],
      IsActive: [],
      AuditDto: []
    });
  }

  populateTotalVehiclesNumbers(dataItem: any) {
    dataItem.totalVehicleNumberService.read('?activeOnly=true')
      .then(result => {
        if (result.length > 0) {
          result.sort((a, b) => a.Description.localeCompare(b.Description));
        }
        dataItem.totalVehService.next(result);
      });
  }
}
